import { Component, OnInit, Input, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DashboardQueries } from '../../../shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '../../../shared/models/WidgetSearch';
import { DashboardService } from '../../../shared/services/dashboard.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { DashboardWidgetService } from '../../../shared/services/dashboardWidget.service';
//import { Item } from '@progress/kendo-angular-grid';
import { filterItem } from '@app/cp/shared/models/filterItem';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'cp-active-invoice-dispute',
    templateUrl: './active-invoice-dispute.component.html',
    styleUrls: ['./active-invoice-dispute.component.scss']
})
export class ActiveInvoiceDisputeComponent implements OnInit, OnDestroy {

    constructor(private svc_globals: GlobalsService, private svc_data: DashboardService, private svc_dashWidget: DashboardWidgetService, private el: ElementRef, qry_rd: DQOIReferenceDataQuery) {
        this.qry_rd = qry_rd;
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.svc_globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
    }

    @Input() chartType: string = 'donut';
    @Input() detailsTitleStart: string = '';
    @Input() inputSearchParams: WidgetSearch;
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);
    subs_dataRefUpdated: Subscription;

    widgetQuery: DashboardQueries = DashboardQueries.activeInvoiceDispute;
    chartSearchFilters: widgetFilters[] =
        [
            widgetFilters.divisions,
            widgetFilters.customer,
            widgetFilters.acctMgr,
            widgetFilters.biller
        ];

    show: boolean = false;
    searchParam: WidgetSearch;
    data  = 0;
    gridData: any;

    detailsTitle: string;
    detailsActive: boolean = false;
    selectedFilters: WidgetSearch;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public activeChildComp: number;
    public contentTypes = WindowContents;
    public dashboardQuery: DashboardQueries = DashboardQueries.activeInvoiceDispute; //.dispatchStatusGauge;

    subs_dataRef: Subscription;
    qry_rd: DQOIReferenceDataQuery;
    referenceData: DQOIReferenceData;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();

    loaderError: boolean = false;

    acctManagerFilters: any;
    customerFilters: any;
    acctClassFilters: any;
    srvConstFilters: any;
    dispatchStatusFilters: any;
    divisionFilters: any;
    regionFilters: any;

    ngOnInit() {
        if (this.inputSearchParams) {
            this.searchParam = this.inputSearchParams;
        }
    }

    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    search(searchParam: WidgetSearch) {
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.svc_globals.userId;
        if (this.searchParam.customSearch || this.searchParam.emptySearch) {
            this.show = false;
            this.showSpinner();
            this.loaderError = false;
            this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe((info: BaseMessageInfo) => {
                if (info.saveError) {
                    this.handleNetworkError(info.messages);
                } else {
                    console.log("widget-reftrack-agd: ", info, this.widgetQuery);
                    this.data = info.primaryReturn;
                }
                this.setFilteredItemsDisplay();
                this.hideSpinner();
            },
            error => this.handleNetworkError(error));
        } else {
            this.show = true;
            this.hideSpinner();
        }

    }
    public refresh() {
        this.search(this.searchParam);
    }
    handleNetworkError(error) {

        this.hideSpinner();
        this.showError();
    }

    showSpinner() {
        this.loaderState.emit(true);
    }

    hideSpinner() {
        this.loaderState.emit(false);
    }

    showError() {
        this.loaderError = true;
        this.loaderErrorState.emit(this.loaderError);
    }

    hideError() {
        this.loaderError = false;
        this.loaderErrorState.emit(this.loaderError);
    }

    public onToggle(): void {
        this.show = !this.show;
    }
    getDetailData() {
        this.setDetailData('');
    }
    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();

        this.hideSpinner();
    }
    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.getDetailData();
    }

    onClosed(e) {
        this.search(this.searchParam);
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

    setFilteredItemsDisplay() {
        this.acctManagerFilters = CommonFunctions.findInObjArr(this.referenceData.acctMgrs, this.searchParam.acctMgrIds);
        this.customerFilters = CommonFunctions.findInObjArr(this.referenceData.customers, this.searchParam.customerIds);
        this.acctClassFilters = CommonFunctions.findInObjArr(this.referenceData.accountClasses, this.searchParam.classIds);
        this.srvConstFilters = CommonFunctions.findInObjArr(this.referenceData.srvConst, this.searchParam.srvConstInt);
        this.dispatchStatusFilters = CommonFunctions.findInObjArr(this.referenceData.dispatchStatus, this.searchParam.statusIds);
        this.divisionFilters = CommonFunctions.findInObjArr(this.referenceData.divisions, this.searchParam.divisionIds);
        this.regionFilters = CommonFunctions.findInObjArr(this.referenceData.regions, this.searchParam.regionIds);
    }
}
